import styled from 'styled-components';

export const ButtonStyle = styled.button`
  position: relative;
  background-color: var(--color-primary);
  color: var(--color-bg);
  padding: 7px 8px;
  width: 35vw;
  border: none;
  border-radius: 8px;
  z-index: 5;
  cursor: pointer;

  &:hover {
    background-color: var(--color-bg);
    color: var(--color-primary);
  }

  @media (min-width: 1023px) {
    width: 10vw;
  }
`;
